import React, { Component } from 'react';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { action } from 'mobx';
import { FormattedMessage } from 'ui/i18n';

import './SubmitWithSuccessModal.scss';

@inject('CartItemsState', 'AppState')
@observer
export default class SubmitWithSuccessModal extends Component {
	static propTypes = {
		CartItemsState: PropTypes.object.isRequired,
		AppState: PropTypes.object.isRequired,
		show: PropTypes.bool.isRequired,
		onRequestClose: PropTypes.func.isRequired,
	};

	redirectLink = this.props.AppState.isCompanyStore
		? '/'
		: '/view-order-history';

	@action
	onCancel() {
		this.props.onRequestClose();
	}

	render() {
		const { show } = this.props;

		return (
			<Modal
				className="ReactModal__Content SubmitWithSuccess"
				overlayClassName="ReactModal__Overlay"
				isOpen={show}
				onRequestClose={this.onCancel.bind(this)}
				contentLabel="Successfully Submitted"
			>
				<h4>
					<span className="glyphicon glyphicon-ok" />
					<strong>
						<FormattedMessage id="cart.orderSubmitted" />
					</strong>
				</h4>
				<hr />
				<h5>
					<FormattedMessage id="cart.thankYouMessage" />
				</h5>
				<h5>
					<FormattedMessage id="cart.emailConfirmationMessage" />
				</h5>

				<div className="row rightSide">
					<Link
						to={{
							pathname: this.redirectLink,
							state: { fromSubmitOrder: true },
						}}
					>
						<button
							className="btn btn-primary pull-right"
							onClick={this.onCancel.bind(this)}
						>
							OK
						</button>
					</Link>
				</div>
			</Modal>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/SubmitWithSuccessModal/index.js